export const getInitialState = () => {
  return {
    introducerList: {},
    introducerDetail: {}
  };
};
